import { makeStyles } from "@material-ui/core";


const useStyles = makeStyles((theme) => ({
    title: {
        textAlign: 'start',
        fontWeight: 'bold',
        fontSize: 30
    },
    panel: {
        margin: 0
    },
    panelNumber: {
        textAlign: 'center',
        color: theme.palette.primary.main
    },
    addButton: {
        textDecoration: 'none',
        fontWeight: 'bold',
        borderColor: 'rgb(75, 179, 176)',
        borderRadius: 40,
        borderWidth: 2,
        width: '35%',
        padding: '14.5px 14px'
    },
    container: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        flexDirection: 'row',
        flexWrap: 'wrap'
    },
    main: {
        // display: 'flex',
        // justifyContent: "space-between",
        // height: '100vh',
        // width: '30%',
        // alignItems: 'center',
    },
    search: {
        width: '35%'
    },
    userName: {
        fontSize: 20,
        fontWeight: 'bold'
    },
    cardPaddStyle: {
        padding: '0px',
        position: 'relative',
        display: "flex",
        justifyContent: "center",
        height: "inherit"
    },
    cardStyle: {
        height: "150px",
        backgroundColor: "#eff3f6"
    },
    cardActionsStyle: {
        display: "flex",
        justifyContent: "space-between",
        width: "100%",
        alignItems: "center",
        marginTop: "10px"
    },
    card: {
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
        width: "75%",
        opacity: 0.1
    }
}));

export default useStyles;
